export const BROWSERSTACK_BASE_URL = import.meta.env.VUE_APP_BROWSERSTACK_BASE_URL || 'https://www.browserstack.com'
export const BROWSERSTACK_ACCOUNT_SETTINGS_URL = `${BROWSERSTACK_BASE_URL}/accounts/settings`
export const BROWSERSTACK_INVITATIONS_URL = `${BROWSERSTACK_BASE_URL}/accounts/manage-users/invitations`
export const BROWSERSTACK_BUG_CAPTURE_PRICING_URL = `${BROWSERSTACK_BASE_URL}/accounts/pricing?product=bug-capture`
export const BROWSERSTACK_LIVE_PRICING_URL = `${BROWSERSTACK_BASE_URL}/accounts/pricing?product=live`
export const BROWSERSTACK_BUG_CAPTURE_URL = `${BROWSERSTACK_BASE_URL}/bug-capture`
export const BROWSERSTACK_WAITLIST_URL = `${BROWSERSTACK_BASE_URL}/accounts/live-plus`
